/**
 * The Infinity Touch customer login link staff hand to a family.
 *
 * It exists in three places — here, and `pinUrl()` in the transactional email
 * templates (api/src/integrations/email/templates/infinity/shared.js). They drifted
 * once already: the admin copies used `PIN=` while the login page reads `pin=`, and
 * URLSearchParams is case-sensitive, so the PIN never auto-filled (TR-21). Build the
 * link here rather than inline so the admin views can't drift apart again.
 */

const DEFAULT_CUSTOMER_SITE = "https://customer.infinitytouch.app";

/** Origin of the customer site. Overridable so the link is clickable on dev. */
export const customerSiteUrl = () => {
  const configured = process.env.REACT_APP_IT_CUSTOMER_URL;
  return (configured && configured.trim() !== "" ? configured : DEFAULT_CUSTOMER_SITE).replace(/\/$/, "");
};

/**
 * @param {string} ref - order_number (ORD-…), the internal order_id, or the case's own
 *   case_code (CASE-…) when no order exists yet; login resolves all three against the
 *   same case PIN. The query param stays named `order_id` so links already in the wild
 *   keep working.
 * @param {string} pin - the case PIN.
 * @returns {string} the full login URL, or "" when there is nothing to link to.
 */
export const buildCustomerLoginUrl = (ref, pin) => {
  if (!ref) return "";
  const q = new URLSearchParams({ order_id: String(ref), pin: pin ? String(pin) : "" });
  return `${customerSiteUrl()}/login?${q.toString()}`;
};
